import { render, staticRenderFns } from "./VerBLModal.vue?vue&type=template&id=3637905b"
import script from "./VerBLModal.vue?vue&type=script&lang=js"
export * from "./VerBLModal.vue?vue&type=script&lang=js"
import style0 from "./VerBLModal.vue?vue&type=style&index=0&id=3637905b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports